import { Action } from '@ngrx/store';
import { TimeWindow, TimeWindowsReq } from '@cemex-core/cmx-api/models/time-windows';

export const RESET = '[Time windows] Reset';

export const LOAD_TIME_WINDOWS = '[Time windows] Load Time Windows';
export const LOAD_TIME_WINDOWS_FROM_PLANT = '[Time windows] Load Time Windows from plant';
export const LOAD_TIME_WINDOWS_COMPLETE = '[Time windows] Load Time Windows Complete';

export class LoadTimeWindowsAction implements Action {
  readonly type = LOAD_TIME_WINDOWS;

  constructor(public payload: TimeWindowsReq) {}
}

export class LoadTimeWindowsFromPlantAction implements Action {
  readonly type = LOAD_TIME_WINDOWS_FROM_PLANT;

  constructor(public payload: TimeWindowsReq) {}
}

/**
 * Fired on receipt of the time-window data
 */
export class LoadTimeWindowsCompleteAction implements Action {
  readonly type = LOAD_TIME_WINDOWS_COMPLETE;

  constructor(public payload: TimeWindow[]) {}
}

export class TimeWindowsResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

export type TimeWindowsActions = LoadTimeWindowsAction | LoadTimeWindowsCompleteAction | TimeWindowsResetAction;
